import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArchivosService {
  readonly header: HttpHeaders;
  constructor(
    private http: HttpClient
  ) {
    this.header = new HttpHeaders({
      "Content-Type": "application/json",
      "Api-Key": environment.apk
    });
  }

  public getPDFBaseN(nombreArchivo: string) : Observable<string> {
    return this.http.get<string>(`${environment.api_archivos}${environment.production ? '/api/v1/archivo/contenido?file_name=' : '/documentos/api/v1/archivo/contenido?file_name='}${nombreArchivo}`, { responseType: 'text' as 'json', headers: this.header  });
  }

  public getXMLBaseN(nombreArchivo: string) : Observable<string> {
    return this.http.get<string>(`${environment.api_archivos}${environment.production ? '/api/v1/archivo/contenido?file_name=' : '/documentos/api/v1/archivo/contenido?file_name='}${nombreArchivo}`, { responseType: 'text' as 'json', headers: this.header  });
  }

  public getPDFByUrl(url_archivo: string): Observable<string> {
    return this.http.get<string>(url_archivo, { responseType: 'text' as 'json', headers: this.header });
  }

  public getXMLByUrl(url_archivo: string): Observable<string> {
    return this.http.get<string>(url_archivo, { responseType: 'text' as 'json', headers: this.header });
  }
}
